import "./bgstars.css"


// **** website background stars *********
const WebBg = () => {
    return (
        <div className="coin_stars">
            <div id="stars" data-v-stars></div>
            <div id="stars2" data-v-stars></div>
            <div id="stars3" data-v-stars></div>
            <div id="stars4" data-v-stars></div>
            <div className="stars55"></div>
        </div>
    )
}

export default WebBg